export default "__VITE_ASSET__8cb46ea0__"